import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Warms critical edge functions on login to prevent cold-start latency.
 * Fires once per session.
 */
export function useKeepAlive() {
  useEffect(() => {
    const key = 'bw-keep-alive-ts';
    const last = parseInt(localStorage.getItem(key) ?? '0', 10);
    const now = Date.now();
    // Only warm once every 30 minutes
    if (now - last < 30 * 60 * 1000) return;

    localStorage.setItem(key, String(now));
    supabase.functions.invoke('keep-alive').catch(() => {
      // silent — best effort
    });
  }, []);
}
